<template>
  <form>
    <validation-observer v-slot="observer">
      <div class="general-form__group form-group row">
        <label
          class="col-4 col-form-label">カテゴリー名</label>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="カテゴリー名"
            rules="required|max:5">
            <b-form-input
              v-model="_value.categoryName"
              type="text"
              hide-header />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__group form-group row">
        <label
          class="col-4 col-form-label">並び順</label>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="並び順"
            rules="required">
            <b-form-input
              v-model="_value.sortOrder"
              type="number"
              hide-header />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__btn row mt-5">
        <div class="col-6">
          <button
            type="button"
            class="btn btn-block btn-cancel"
            @click="onClickCancel">
            キャンセル
          </button>
        </div>
        <div class="col-6">
          <button
            type="button"
            class="btn btn-block btn-primary"
            @click="observer.passes(onSubmit)">
            {{ isEdit ? '保存' : '作成' }}
          </button>
        </div>
      </div>
    </validation-observer>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      // 親コンポーネントの現在のpropsに書き換える。
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    onSubmit(){
      this.$emit('submit')
    },
    onClickCancel(){
      this.$router.push('/admin/categories/')
    }
  }
}
</script>

<style lang="scss" scoped>
.category {
  &__item {
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;
  }

  &__icon{
    vertical-align: middle;
    display: inline-block;
  }

  &__btn {
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
      padding: auto;
      line-height: auto;
    }
  }

  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }
}
</style>